import React, { useEffect, useState, useContext } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import Button from '@material-ui/core/Button';
import { DialogActions } from '@material-ui/core';
import { Link, useHistory } from 'react-router-dom';
import TopNav from 'components/TopNav';
import * as authApi from 'api/auth';
import { useQueryClient } from 'react-query';
import { useSelector } from 'react-redux';
import { convertSmsStatusText, pathDisplayPageAfterLogin, textFooterEnv } from '../../../utils/utils';
import {
  DISPLAY_BUTTON,
  OTP_VERIFY_STATUS,
  STATE_USER_TASK_ACTION,
  STATUS_SMS_OTP,
  TYPE_LOGIN,
} from '../../../config/constants';
import style from './style.module.scss';
import socketNexmoMaintenance from 'utils/socketNexmoMaintenance';
import socketServerNexmo from 'socket/socketServerNexmo';
import LoadingInCustom from 'components/LoadingInCustom';
import MuiThemeProvider from '@material-ui/core/styles/MuiThemeProvider';
import FormControl from '@material-ui/core/FormControl';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { AuthContext } from '../../../context/AuthContext';
import { AppContext } from '../../../context/AppContext';
import { customThemeRadio, GreenRadio } from '../../../themeMui/customer-radio';


const styleWrapTitle = {
  fontWeight: 500,
  fontSize: '18px',
  marginTop: '3px',
};

const requiredStyle = { color: 'red' };

function Login() {
  const appContext = useContext(AppContext);
  const authContext = useContext(AuthContext);
  const history = useHistory();
  const [phone, setPhone] = useState('');
  const [email, setEmail] = useState('');
  const [visible, setVisible] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [messageErr, setMessageErr] = useState();
  const queryClient = useQueryClient();
  const envUi = authContext.envUi;
  const envInfoList = useSelector((state) => state.envInfo.data);
  const [dataUser, setDataUser] = useState();
  const [isUploading, setIsUploading] = useState(false);
  const [typeLogin, setTypeLogin] = useState(TYPE_LOGIN.PHONE)

  useEffect(() => {
    if (appContext.isAuthenticated) {
      history.push({ pathname: pathDisplayPageAfterLogin(envUi?.displayPageAfterLogin) })
    }
  }, [appContext.isAuthenticated]);

  useEffect(() => {
    if(dataUser){
      socketServerNexmo.connect();
      socketNexmoMaintenance(getDataServerNexmo);
      setIsUploading(true)
    }
  }, [dataUser]);

  const getDataServerNexmo = (data) => {
    if (
      dataUser?.messageInfo &&
      data &&
      dataUser?.messageInfo?.to == data?.msisdn &&
      dataUser?.messageInfo?.messageId == data?.messageId &&
      typeLogin
    ) {
      if(dataUser?.registerStatus == OTP_VERIFY_STATUS.OTPNotVerified && !([STATUS_SMS_OTP.REJECTED,STATUS_SMS_OTP.FAILED,STATUS_SMS_OTP.UNKNOWN].includes(+data?.errCode))){
        setOpenModal(true)
        setIsUploading(false)
        authApi.updateOtpInfo({
          otpId: dataUser?.messageInfo?.otpInfo?.id,
          network: dataUser?.messageInfo?.network,
          statusSms: STATUS_SMS_OTP.DELIVERED,
        });
        socketServerNexmo.disconnect();
        return
      }
      if(dataUser?.registerStatus != OTP_VERIFY_STATUS.OTPNotVerified && !([STATUS_SMS_OTP.REJECTED,STATUS_SMS_OTP.FAILED,STATUS_SMS_OTP.UNKNOWN].includes(+data?.errCode))){
        setIsUploading(false)
        history.push({ pathname: typeLogin == TYPE_LOGIN.PHONE ? `${process.env.RAZZLE_PUBLIC_URL}/verify_phone` : `${process.env.RAZZLE_PUBLIC_URL}/verify_email` });
        authApi.updateOtpInfo({
          otpId: dataUser?.messageInfo?.otpInfo?.id,
          network: dataUser?.messageInfo?.network,
          statusSms: STATUS_SMS_OTP.DELIVERED,
        });
        socketServerNexmo.disconnect();
        return
      }
      if(([STATUS_SMS_OTP.REJECTED,STATUS_SMS_OTP.FAILED,STATUS_SMS_OTP.UNKNOWN].includes(+data?.errCode))){
        setIsUploading(false)
        setAlertMessage(convertSmsStatusText(+data?.errCode));
        authApi.updateOtpInfo({
          otpId: dataUser?.messageInfo?.otpInfo?.id,
          network: dataUser?.messageInfo?.network,
          statusSms: +data?.errCode,
        });
        socketServerNexmo.disconnect();
        return
      }
    }
  };

  const handleSubmit = async () => {
    if(typeLogin && (!!email || !!phone)){
      let data = {
        phone: phone,
        email: email,
        typeLogin: +typeLogin,
        deviceType: 2,
      };

      try {
        const { data: user } = await authApi.login(data);
        if (typeof window !== 'undefined')  {
          queryClient.setQueryData('user', user);
          sessionStorage.setItem(STATE_USER_TASK_ACTION, JSON.stringify(user));
        }

        if (user?.registerStatus == OTP_VERIFY_STATUS.OTPNotVerified) {
          setOpenModal(true);
        } 

        if(user?.registerStatus != OTP_VERIFY_STATUS.OTPNotVerified){
          history.push({ pathname: typeLogin == TYPE_LOGIN.PHONE ? `${process.env.RAZZLE_PUBLIC_URL}/verify_phone` : `${process.env.RAZZLE_PUBLIC_URL}/verify_email`});
          return
        }
      } catch (e) {
        setAlertMessage(e.response?.data?.message);
      }
    }
  };

  const setAlertMessage = (message) => {
    setMessageErr(message);
    setVisible(true);
  };

  const handleClose = () => {
    setVisible(false);
  };

  useEffect(() => {
    if (visible) {
      setTimeout(() => {
        handleClose();
      }, 3000);
    }
  }, [visible]);

  const handleKeyUp = (event) => {
    if (event.keyCode === 13) {
      handleSubmit();
    }
  };

  const textFooter = () => {
    return textFooterEnv(envInfoList ?? []);
  };

  const handleNextVerifyOtp = () => {
    history.push({ pathname: typeLogin == TYPE_LOGIN.PHONE ? `${process.env.RAZZLE_PUBLIC_URL}/verify_phone` : `${process.env.RAZZLE_PUBLIC_URL}/verify_email` });
    return;
  };

  return (
    <div
      style={{
        overflow: 'auto',
        height: '100vh',
        backgroundColor: 'var(--white)',
        maxWidth: 560,
        margin: 'auto',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <LoadingInCustom loading={isUploading} isTextLoading={isUploading} colorLoading="#1a90ff"/>
      <TopNav name={'ログイン'} hasBackIcon={true} />

      <React.Fragment>
        <div className={`back_white_wrap align-top`}>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <div className="align-center mb-heading">
              <span className="stick-icon">&nbsp;</span>
              <span className="title font-4">ログイン</span>
            </div>
          </div>
          <div className={`align-center`}>
            <span className="title font-3">
              ログインされる方式をお選び下さい。
              <br />
              携帯番号またはメールアドレスが不明な場合は下記よりご確認下さい。
            </span>
          </div>
          <div className="font-2" style={styleWrapTitle}>
            <span style={requiredStyle}>*</span>ログイン種類</div>
            <MuiThemeProvider theme={customThemeRadio}>
              <FormControl component="fieldset" className={'fieldset'}>
                <RadioGroup aria-label="typeLogin"
                            name="typeLogin"
                            value={`${typeLogin}`}
                            className='radio-group-custom'
                            onChange={(e) => setTypeLogin(e.target.value)}>
                    <FormControlLabel
                      value={`${TYPE_LOGIN.PHONE}`}
                      control={<GreenRadio />}
                      label={'携帯番号でログイン'}
                      labelPlacement="start" />
                    <FormControlLabel
                      value={`${TYPE_LOGIN.EMAIL}`}
                      control={<GreenRadio />}
                      label={'メールアドレスでログイン'}
                      labelPlacement="start" />
                </RadioGroup>
              </FormControl>
            </MuiThemeProvider>
          <div style={{ marginTop: 16, fontSize: 15 }}>
            <label className="font-2">携帯番号</label>
            <input
              style={{ fontSize: 16, width: '100%' }}
              id="name"
              type="text"
              name="phone"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              onKeyUp={handleKeyUp}
              placeholder="登録した携帯番号を入力して下さい"
              disabled={+typeLogin === TYPE_LOGIN.EMAIL}
            />
          </div>
          <div style={{ marginTop: 16, fontSize: 15 }}>
            <label className="font-2">メールアドレス</label>
            <input
              style={{ fontSize: 16, width: '100%' }}
              id="email"
              type="text"
              name="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              onKeyUp={handleKeyUp}
              placeholder="登録したメールアドレスを入力して下さい"
              disabled={+typeLogin === TYPE_LOGIN.PHONE}
            />
          </div>

          <br />
          <center>
            <div id="sign-in-button"></div>
          </center>
          {envUi?.displayLoginButton === DISPLAY_BUTTON.SHOW && (
            <div style={{ display: 'flex', justifyContent: 'center', marginTop: 50 }}>
              <div className="btn-main btn-submit" onClick={handleSubmit}>
                <div>ログイン</div>
              </div>
            </div>
          )}

          <Link
            className="btn-link"
            to={`${process.env.RAZZLE_PUBLIC_URL}/contactnologin`}
          >
            <span className="font-2">電話番号またはメールアドレスを忘れた方はこちら</span>
          </Link>
          <Link
            className="btn-link_1"
            to={`/` }>
            <span className="font-2">トップに戻る</span>
          </Link>
        </div>
      </React.Fragment>

      <div style={{ marginTop: 'auto', display: 'flex', justifyContent: 'center', textAlign: 'center' }}>
        <p style={{ color: 'var(--text3)' }} className="font-3" dangerouslySetInnerHTML={{ __html: textFooter() }}></p>
      </div>

      <Dialog
        open={visible}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        style={{ opacity: 0.6 }}
      >
        <DialogContent style={{ backgroundColor: 'var(--black)' }} onClick={handleClose}>
          <span style={{ color: 'var(--white)', fontWeight: 'bold' }}>{messageErr}</span>
        </DialogContent>
      </Dialog>

      <Dialog
        open={openModal}
        onClose={() => setOpenModal(false)}
        aria-labelledby="form-dialog-title"
        style={{ borderRadius: '20px !important' }}
        className={'d-modal-handle-wrapper'}
        classes={{ paper: 'd-pager-modal-custom d-pager-modal-wrapper' }}
      >
        <div className={`${style.name__lable} box-header`}>
          <div>携帯電話番号再認証</div>
        </div>
        <DialogContent className={'xzz'}>
          <div className="font-3" style={{ marginTop: 20, lineHeight: 'normal' }}>
            <p style={{ margin: 0, padding: 0 }}>電話番号の認証が終わっておりません。</p>
            <p style={{ margin: 0, padding: 0 }}>6桁の認証番号をお送りしたので認証を行って下さい</p>
          </div>
        </DialogContent>
        <DialogActions style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <Button className={`${style.button__save__profile} btn-main`} onClick={() => setOpenModal(false)}>
            キャンセル
          </Button>
          <Button
            className={`${style.button__save__profile} btn-sub`}
            onClick={() => handleNextVerifyOtp()}
            style={{ cursor: 'pointer' }}
          >
            はい
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default Login;
